import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { userActions } from "store/user/user.slice";

function TermsConditions({
  isAsk,
  country,
}: {
  isAsk?: boolean;
  country?: string;
}) {
  const dispatch = useDispatch();
  const myElement = document.getElementById("isAsk");

  useEffect(() => {
    if (isAsk === true) {
      myElement?.scrollIntoView({
        behavior: "smooth",
      });
    }

    if (country) dispatch(userActions.setCountry(country!));
  });

  // src/pages/TermsConditions.tsx or similar path

  return (
    <section className="relative pb-32 pt-20 lg:px-32 pt-20 w-full">
      <h1 className="text-3xl font-bold mb-6">Vhicasar Homes Terms and Conditions</h1>
      <p className="mb-2">
        Effective Date: <strong>July 29, 2025</strong>
      </p>

      <section className="mb-6">
        <p>
          Welcome to Vhicasar Homes. By accessing or using our mobile application you
          agree to be bound by these Terms and Conditions. Please read them
          carefully before using our services.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">1. Acceptance of Terms</h2>
        <p>
          By registering or using Vhicasar Homes, you confirm that you have read,
          understood, and agreed to these Terms. If you do not agree, please do
          not use the app.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">2. About Vhicasar Homes</h2>
        <p>
          Vhicasar Homes is a platform that connects users with home-related services
          such as laundry, house rentals, plumbing, and other similar services.
          We serve as a medium to find and communicate with service providers
          but do not directly offer these services ourselves.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">3. User Eligibility</h2>
        <p>
          Use of the app requires registration. You must provide accurate,
          current, and complete information. Users must not impersonate another
          individual or provide false information. There is no strict age
          restriction, but users under 18 are encouraged to use the app with
          parental guidance.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">4. Personal Information</h2>
        <p>
          When registering or using the app, you may provide personal
          information including:
        </p>
        <ul className="list-disc list-inside ml-4">
          <li>Name</li>
          <li>Email</li>
          <li>Phone number</li>
          <li>Location</li>
        </ul>
        <p className="mt-2">
          This information is collected in line with our{" "}
          <a
            href="/privacy-policy"
            className="text-blue-600 underline dark:text-blue-400"
          >
            Privacy Policy
          </a>{" "}
          and is used solely to enhance your app experience.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">5. User Responsibilities</h2>
        <p>You agree to:</p>
        <ul className="list-disc list-inside ml-4">
          <li>Use the app only for lawful purposes.</li>
          <li>Not misuse the chat or other user interaction features.</li>
          <li>Not post or share illegal, abusive, or offensive content.</li>
        </ul>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">6. Vendor-Specific Terms</h2>
        <p>
          Vendors (service providers) may be subject to additional terms,
          including subscriptions or listing fees. These terms will be made
          available during vendor onboarding.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">7. Third-Party Services</h2>
        <p>We may integrate third-party services such as:</p>
        <ul className="list-disc list-inside ml-4">
          <li>Google Maps (for location-based services)</li>
          <li>Firebase Notifications (for alerts and messages)</li>
        </ul>
        <p className="mt-2">
          By using Vhicasar Homes, you agree to comply with the terms of these
          third-party services.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">8. No Payment Processing</h2>
        <p>
          Vhicasar Homes does not currently process payments through the app. Any
          payment for services should be done outside the platform, and users do
          so at their own risk.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">9. Intellectual Property</h2>
        <p>
          All content, branding, and materials on Vhicasar Homes are the property of
          Vhicasar Homes and its licensors. You may not copy, modify, distribute, or
          reuse any part of the app without permission.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">
          10. Limitation of Liability
        </h2>
        <p>
          Vhicasar Homes is a platform for connecting users with service providers. We
          do not guarantee the quality, safety, or legality of services
          rendered. Users and vendors are solely responsible for their
          interactions and transactions.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">11. Termination</h2>
        <p>
          We reserve the right to suspend or terminate your account at any time
          for violations of these Terms.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">12. Governing Law</h2>
        <p>
          These Terms are governed by the laws of the Federal Republic of
          Nigeria. Any disputes arising will be subject to the jurisdiction of
          Nigerian courts.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">13. Changes to Terms</h2>
        <p>
          We may update these Terms from time to time. Continued use of the app
          after changes are made constitutes acceptance of those changes.
        </p>
      </section>

      <section className="mb-6">
        <h2 className="text-xl font-semibold mb-2">14. Contact Us</h2>
        <p>
          If you have any questions about these Terms, please contact us at:
          <br />
          Email:{" "}
          <a
            href="mailto:support@vhicasar.com"
            className="text-blue-600 underline dark:text-blue-400"
          >
            support@vhicasar.com
          </a>
        </p>
      </section>
    </section>
  );
}

export default TermsConditions;
